import { Link, useNavigate,useParams } from "react-router-dom";
import React, { useState, useEffect } from "react"
import axios from "axios";
import { linksurl, WorkshopPublicURL } from '../../../apis/urls'
import { decode } from "html-entities";
import moment from "moment";
import { message } from "antd";


const SessionView = () => {

    useEffect(() => {
        SessionListing();
    },[]
    );

    let navigate = useNavigate();
    let urole = localStorage.getItem('userrole');

    let token = "Bearer "+localStorage.getItem('token');
    // console.log(token)

    const instance = axios.create({
        baseURL: linksurl,
        timeout: 1000000,
        headers: {'authorization': token}
      });


    const { wid, sid } = useParams();
    const[ result,setResult ] = useState('');

    const SessionListing = ()=>{
        let token = "Bearer "+localStorage.getItem('token');
        console.log(token)

        const instance = axios.create({
            baseURL: WorkshopPublicURL+"workshop/session/view/"+sid,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            console.log(res.data.data)
            setResult(res.data.data);
          });
    }

    const DeleteEvent = () => {

        let r = window.confirm("Are you sure you want to delete this Session?");

        if(r == true){
            
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: WorkshopPublicURL+"workshop/session/delete/"+sid,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                if(response.data.message === "success"){
                    navigate("/sessions/"+wid)
                }else{
                    message.success('Please delete workshop')
                }
            
            }).catch((error) =>{
                
                console.log('error',error.message)
            });
        }
    }


    return(
        <div>
            <aside class="right-side areas">    
                <div class="content-area dash-contentss">
                   
                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <i class="icon-library1"></i>
                            <h2 class="page-title">Session - {decode(result.name)}</h2>
                        </div>

                        <div class="page-rightside-action-column"></div>
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to={"/sessions/"+wid}>Session</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Session View</li>
                        </ol>
                    </nav>

                    <div className="tab-content">

                        <div id="generalinfo" class="container tab-pane active"><br/>
                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>Session Name</label>
                                    <div>{decode(result.name)}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Start Date</label>
                                    <div>
                                    {moment(result.start_date).format('MMMM DD, YYYY') +", "+ moment(result.start_date).format('hh:mm A')}
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>End Date</label>
                                    <div>
                                    {moment(result.end_date).format('MMMM DD, YYYY') +", "+ moment(result.end_date).format('hh:mm A')}
                                    </div>
                                </div>
                                
                            </div>

                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>Create Date</label>
                                    <div>
                                    {moment(result.createdAt).format('MMMM DD, YYYY') +", "+ moment(result.createdAt).format('hh:mm A')}
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>Update Date</label>
                                    <div>
                                    {moment(result.updatedAt).format('MMMM DD, YYYY') +", "+ moment(result.updatedAt).format('hh:mm A')}
                                    </div>
                                </div>
                                
                            </div>

                            {urole === "SUPERADMIN"?
                            <div className="list-action-wrpr showicons roundicons-text">
									<div className="list-action-wrpr">
										<Link   to={"/workshop/session/update/"+wid+"/"+sid}  data-toggle="tooltip" title="Edit">
											<i class="edit icon-pencil3"></i><span>Update</span>
										</Link>
                                        <button data-toggle="tooltip" 
                                        style={{backgroundColor: '#fff'}} onClick={ ()=> { DeleteEvent() } }  title="Delete"  ><a><i  class="delete icon-close1"
                                        ></i><span>Delete</span></a></button>

									</div>
								</div>:null}


                        </div>

                    </div>
                    


                </div>
            </aside>

        </div>
    )
}

export default SessionView;